import { createReducer, on } from '@ngrx/store';

import { JourneyNavigationActionsUnion } from '@app/stp/state/actions/journey-navigation.actions';
import { JourneyNavigationActions } from '../actions';

import { FeatureState } from '@global/infrastructure/interfaces/feature-state';
import { JourneyPath } from '@global/infrastructure/interfaces/journey-path-state';

export interface JourneyNavigationState {
  nextJourneyDetails: FeatureState;
  journeyPath?: JourneyPath;
  navDirection?: number;
}

export const initialState: JourneyNavigationState = {
  nextJourneyDetails: {
    panelConfig: { isVisible: true },
    navConfig: []
  },
  journeyPath: {
    path : ['dashboard']
  },
  navDirection: 0
};

const journeyNavigationReducer = createReducer(
  initialState,
  on(JourneyNavigationActions.loadNextJourneyDetails, (state, { nextJourneyDetails }) => ({ ...state, nextJourneyDetails })),
  on(JourneyNavigationActions.buildJourneyPath, (state, { journeyPath }) => ({ ...state, journeyPath })),
  on(JourneyNavigationActions.setNavDirection, (state, { navDirection }) => ({ ...state, navDirection })),
  on(JourneyNavigationActions.changeButtonStatus, (state, { id, status }) => {
    const { nextJourneyDetails: { navConfig }} = state;
    const buttonIndex = navConfig.findIndex(b => b.id === id);
    if (buttonIndex > -1) {
      return {
        ...state,
        nextJourneyDetails: {
          ...state.nextJourneyDetails,
          navConfig: [
            ...navConfig.slice(0, buttonIndex),
            {...navConfig[buttonIndex], isDisabled: status},
            ...navConfig.slice(buttonIndex + 1)
          ]
        }
      };
    }
    return state;
  }),
  on(JourneyNavigationActions.changeButtonVisibility, changeButtonStatus),
  on(JourneyNavigationActions.changeButtonLabel, changeButtonLabel),

);

export function reducer(state: JourneyNavigationState | undefined, action: JourneyNavigationActionsUnion) {
  return journeyNavigationReducer(state, action);
}

// TODO: reuse this function for change changeButtonStatus
function changeButtonStatus(state: any, {id, status}: {id: string, status: boolean}) {
  const { nextJourneyDetails: { navConfig }} = state;
  const buttonIndex = navConfig.findIndex(b => b.id === id);
  if (buttonIndex > -1) {
    return {
      ...state,
      nextJourneyDetails: {
        ...state.nextJourneyDetails,
        navConfig: [
          ...navConfig.slice(0, buttonIndex),
          {...navConfig[buttonIndex], isHidden: status},
          ...navConfig.slice(buttonIndex + 1)
        ]
      }
    };
  }
  return state;
}

function changeButtonLabel(state: any, {id, label}: {id: string, label: string}) {
  const { nextJourneyDetails: { navConfig }} = state;
  const buttonIndex = navConfig.findIndex(b => b.id === id);
  if (buttonIndex > -1) {
    return {
      ...state,
      nextJourneyDetails: {
        ...state.nextJourneyDetails,
        navConfig: [
          ...navConfig.slice(0, buttonIndex),
          {...navConfig[buttonIndex], label},
          ...navConfig.slice(buttonIndex + 1)
        ]
      }
    };
  }
  return state;
}
